import { fromJS } from 'immutable';
import Segment from '../../helpers/segment';
import { LanguagesActionTypes } from './actions';
import { createReducer } from '../../helpers/store';

const initialState = fromJS({
  errors: '',
  isLoading: true,
  languages: []
});

/**
 * Called when get languages request is initiated.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */

export const handleGetLanguagesRequest = (state, action) => {
  Segment.track('Getting languages');
  return state.set('isLoading', true).set('errors', '');
};

/**
 * Called when the get languages request fails.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */

export const handleGetLanguagesFailure = (state, action) => {
  Segment.track('Failed to get languages', { error: action.data.error });
  return state
    .set('isLoading', false)
    .set(
      'errors',
      action.data.error || 'Sorry, we were unable to load your languages.'
    );
};

/**
 * Called when get language request is successful.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */

export const handleGetLanguagesSuccess = (state, action) => {
  Segment.track('Got languages');
  const languages = fromJS(action.response.data).map(language => {
    return {
      value: language.get('slug'),
      label: language.get('name')
    };
  });

  return state
    .set('errors', '')
    .set('languages', languages)
    .set('isLoading', false);
};

export const languagesReducer = createReducer(initialState, {
  [LanguagesActionTypes.GET_LANGUAGES_REQUEST]: handleGetLanguagesRequest,
  [LanguagesActionTypes.GET_LANGUAGES_SUCCESS]: handleGetLanguagesSuccess,
  [LanguagesActionTypes.GET_LANGUAGES_FAILURE]: handleGetLanguagesFailure
});



/** WEBPACK FOOTER **
 ** ./src/state/languages/reducer.js
 **/